import gql from 'graphql-tag'
import api from './apiClient'

export default {
  cierreCaja: (caja, sesion, nombre, montosTotales, balance, movimiento, contador) =>
    api
      .send({
        query: gql`
          mutation cierreCaja(
            $caja: ID!
            $sesion: ID!
            $nombre: String!
            $montosTotales: MontosTotalesInput!
            $balance: BalanceInput!
            $movimiento: MovimientoInput!
            $contador: [ContadorInput]
          ) {
            Sesion {
              cierreCaja(
                caja: $caja
                sesion: $sesion
                nombre: $nombre
                montosTotales: $montosTotales
                balance: $balance
                movimiento: $movimiento
                contador: $contador
              )
            }
          }
        `,
        variables: {
          caja,
          sesion,
          nombre,
          montosTotales,
          balance,
          movimiento,
          contador
        }
      })
      .then(result => result.data.data.Sesion.cierreCaja),

  finCaja: (caja, sesion, movimiento) =>
    api
      .send({
        query: gql`
          mutation finCaja($caja: ID!, $sesion: ID!, $movimiento: MovimientoInput!) {
            Sesion {
              finCaja(caja: $caja, sesion: $sesion, movimiento: $movimiento)
            }
          }
        `,
        variables: {
          caja,
          sesion,
          movimiento
        }
      })
      .then(result => result.data.data.Sesion.finCaja),

  readTotal: emisor =>
    api
      .send({
        query: gql`
          query readTotal($emisor: ID!) {
            Sesion {
              readTotal(emisor: $emisor)
            }
          }
        `,
        variables: {
          emisor
        }
      })
      .then(result => result.data.data.Sesion.readTotal),

  readAllByEmisor: (emisor, cursor, limit = 10, filter = null) =>
    api
      .send({
        query: gql`
          query readAllByEmisor($emisor: ID!, $cursor: String, $limit: Int, $filter: Filter) {
            Sesion {
              readAllByEmisor(emisor: $emisor, cursor: $cursor, limit: $limit, filter: $filter) {
                feed {
                  _id
                  caja {
                    _id
                    name
                  }
                  userSession {
                    _id
                    fullname
                  }
                  user {
                    _id
                    fullname
                  }
                  status
                  state
                  saldo
                  createdAt
                  updatedAt
                  completedAt
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          cursor,
          limit,
          filter
        }
      })
      .then(result => result.data.data.Sesion.readAllByEmisor),

  create: input =>
    api
      .send({
        query: gql`
          mutation CREATE($input: SesionInput!) {
            Sesion {
              create(input: $input) {
                _id
                createdAt
                completedAt
              }
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.Sesion.create),

  // setStatus: (_id, status) =>
  //   api
  //     .send({
  //       query: gql`
  //         mutation SET_STATUS($_id: ID!, $status: SesionStatus!) {
  //           Sesion {
  //             setStatus(_id: $_id, status: $status)
  //           }
  //         }
  //       `,
  //       variables: {
  //         _id,
  //         status
  //       }
  //     })
  //     .then(result => result.data.data.Sesion.setStatus),

  readBySearchString: (emisor, searchString) =>
    api
      .send({
        query: gql`
          query readBySearchString($emisor: ID!, $searchString: String!) {
            Sesion {
              readBySearchString(emisor: $emisor, searchString: $searchString) {
                feed {
                  _id
                  caja {
                    _id
                    name
                  }
                  userSession {
                    _id
                    fullname
                  }
                  status
                  state
                  saldo
                  createdAt
                  updatedAt
                  completedAt
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          searchString
        }
      })
      .then(result => result.data.data.Sesion.readBySearchString),

  // readByStatus: (emisor, restaurant, status) =>
  //   api
  //     .send({
  //       query: gql`
  //         query readByStatus($emisor: ID!, $restaurant: ID!, $status: [String!]) {
  //           Sesion {
  //             readByStatus(emisor: $emisor, restaurant: $restaurant, status: $status) {
  //               _id

  //               userSession {
  //                 _id
  //                 fullname
  //               }
  //               name
  //               status
  //               createdAt
  //               updatedAt
  //             }
  //           }
  //         }
  //       `,
  //       variables: {
  //         emisor,
  //         restaurant,
  //         status
  //       }
  //     })
  //     .then(result => result.data.data.Sesion.readByStatus)

  readById: _id =>
    api
      .send({
        query: gql`
          query readById($_id: ID!) {
            Sesion {
              readById(_id: $_id) {
                _id
                status
                state
                createdAt
                updatedAt
                completedAt
                balance {
                  esperado
                  caja
                  dif
                }
                contador {
                  moneda
                  totalMoneda
                  cantidadMoneda
                }
                caja {
                  _id
                  name
                }
                userSession {
                  _id
                  fullname
                }
                cuentaContable
              }
            }
          }
        `,
        variables: {
          _id
        }
      })
      .then(result => result.data.data.Sesion.readById),

  readByUser: user =>
    api
      .send({
        query: gql`
          query readByUser($user: ID!) {
            Sesion {
              readByUser(user: $user) {
                _id
                status
                state
                createdAt
                updatedAt
                caja {
                  _id
                  name
                }
                userSession {
                  _id
                  fullname
                }
                cuentaContable
              }
            }
          }
        `,
        variables: {
          user
        }
      })
      .then(result => result.data.data.Sesion.readByUser),

  readSaldo: _id =>
    api
      .send({
        query: gql`
          query readSaldo($_id: ID!) {
            Sesion {
              readSaldo(_id: $_id)
            }
          }
        `,
        variables: {
          _id
        }
      })
      .then(result => result.data.data.Sesion.readSaldo)
}
